import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentUserService } from '../services/current-user.service';

export const redirectToManagerOrServiceProvider: CanMatchFn = async () => {
  const router = inject(Router);
  const user = inject(CurrentUserService);

  const route = user.isManager ? 'manager' : 'service-provider';
  console.log('Redirect to:', route);

  await router.navigate(['webapp', 'projects', route]);

  console.log('Redirected to:', route);

  return true;
};
